// this is so it is backwards compatible
import history from '@send-services/history';

export default history;
